import privacy from './zh-CN/privacy'
import user from './zh-CN/user'
import login from './zh-CN/login'
import admin from './zh-CN/admin'

export default {
  ...privacy,
  ...user,
  ...login,
  ...admin,
}
